import { GridApi } from "ag-grid-community";
import { Button } from "@/components/UI/Button";
import { clearAllGridFilters } from "@/lib/agGridFilterHelper";
import {
  isFilteredToEmpty,
  NO_MATCHING_ROWS_MESSAGE,
  NO_ROWS_MESSAGE,
} from "@/lib/agGridOverlayHelper";

// LQC-2482: shared noRowsOverlayComponent. When filters hide every row it names
// the cause and offers a clear-filters button (see agGridOverlayHelper.ts for
// the AG Grid 35 upgrade note).
const AGGridNoRowsOverlay = ({ api }: { api: GridApi }) => {
  const filteredToEmpty = isFilteredToEmpty(api);
  return (
    <div
      data-testid="AGGridNoRowsOverlayContainer"
      id="AGGridNoRowsOverlayContainer"
      className="flex flex-col items-center gap-2"
    >
      <span className="agLoadingOverlayMessage">
        {filteredToEmpty ? NO_MATCHING_ROWS_MESSAGE : NO_ROWS_MESSAGE}
      </span>
      {filteredToEmpty && (
        <Button
          data-testid="AGGridNoRowsOverlayClearFiltersButton"
          id="AGGridNoRowsOverlayClearFiltersButton"
          variant="secondaryBlueActionAtTradeCreation"
          size="button_sm_medium"
          className="pointer-events-auto px-2" // .ag-overlay wrapper is pointer-events: none
          onClick={() => clearAllGridFilters(api)}
        >
          Clear filters
        </Button>
      )}
    </div>
  );
};

export default AGGridNoRowsOverlay;
